import React, { useMemo } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { FIELD_PADDING } from '../SettlePayment/const';

const AgentNameAutocomplete = ({ travelAgents = [], selectedAgentId = null, onChange, placeholder = '' }) => {
	const { t } = useTranslation();

	// Find the currently selected agent object
	const selectedAgent = useMemo(() => {
		return travelAgents.find((a) => String(a._id) === String(selectedAgentId)) || null;
	}, [travelAgents, selectedAgentId]);

	const filterOptions = createFilterOptions({
		matchFrom: 'start',
		stringify: (agent) => {
			const name = agent.full_name || agent.name || '';
			return name;
		},
	});

	return (
		<Autocomplete
			value={selectedAgent}
			options={travelAgents}
			getOptionLabel={(a) => {
				if (!a) return '';
				return a.full_name || a.name || '';
			}}
			renderOption={(props, option, index) => {
				const key = `listItem-${option._id}`;
				const name = option.full_name || option.name || '';
				return (
					<li {...props} key={key}>
						<div >
							<div>{name}</div>
							{option.duplicate_name && <div style={{ fontSize: '0.75rem', color: '#9e9e9e' }}>{option.email}</div>}
						</div>
					</li>
				);
			}}
			isOptionEqualToValue={(opt, val) => String(opt._id) === String(val._id)}
			filterOptions={filterOptions}
			onChange={(e, val) => onChange?.(val ? val : null)}
			size="small"
			renderInput={(params) => (
				<TextField
					{...params}
					placeholder={placeholder || t('FindByAgentName')}
					variant="outlined"
					fullWidth
					sx={FIELD_PADDING}
					InputProps={{
						...params.InputProps,
						endAdornment: (
							<>
								{selectedAgentId ? (
									<InputAdornment position="end">
										<IconButton onClick={() => onChange?.(null)} disableRipple size="small">
											<CloseIcon />
										</IconButton>
									</InputAdornment>
								) : (
									params.InputProps.endAdornment
								)}
							</>
						),
					}}
				/>
			)}
		/>
	);
};

export default AgentNameAutocomplete;
